import styled from "styled-components";

import { colors } from "../../../constants/colors";

export type StyledTextAreaProps = {
  height?: string;
  width?: string;
};

export const StyledTextArea = styled.textarea`
  background: ${colors.form.background};
  font-size: 16px;
  height: ${({ height }: StyledTextAreaProps) => height || "6rem"};
  width: ${({ width }: StyledTextAreaProps) => width || "10rem"};
  padding: 0.5rem 0.75rem 0.5rem;
  box-sizing: border-box;
  border-radius: 5px;
  border: 0px;
  resize: none;

  &:disabled {
    background: ${colors.disable};
  }

  &:focus {
    background: ${colors.form.focused};
  }
`;
